import { Vec3, type Vec3Like } from './vector';

// ---------------------------------------------------------------------------
// Shared utilities
// ---------------------------------------------------------------------------

let _counter = 0;

/** Generate a simple unique id for renderable objects. */
export function uid(prefix = 'obj'): string {
  return `${prefix}_${Date.now().toString(36)}_${(++_counter).toString(36)}`;
}

/** Resolve a File | url | objectUrl into a usable URL string. */
export function resolveAssetUrl(options: { url?: string; file?: File; objectUrl?: string }): {
  url: string;
  revokeOnDispose?: string;
} {
  if (options.objectUrl) {
    return { url: options.objectUrl };
  }
  if (options.url) {
    return { url: options.url };
  }
  if (options.file) {
    const objectUrl = URL.createObjectURL(options.file);
    return { url: objectUrl, revokeOnDispose: objectUrl };
  }
  throw new Error('No url, file, or objectUrl provided for asset.');
}

// ---------------------------------------------------------------------------
// Coordinate system conversion utilities
//
// Core uses right-handed Y-up (same as Three.js / OpenGL).
// Adapters for left-handed systems (e.g. Babylon.js) should use these helpers.
// ---------------------------------------------------------------------------

/**
 * Convert a position from core (right-handed Y-up) to left-handed Y-up (Babylon).
 * In practice this negates the Z axis.
 */
export function rhToLH(v: Vec3Like): Vec3 {
  return new Vec3(v.x, v.y, -v.z);
}

/**
 * Convert a position from left-handed Y-up (Babylon) back to core (right-handed Y-up).
 */
export function lhToRH(v: Vec3Like): Vec3 {
  return new Vec3(v.x, v.y, -v.z);
}
